import { ContentDistribution } from "./ContentDistribution";

export default ContentDistribution;